import http from "@/app/plugins/axios/axios";

function post(resource, jsonToSubmit) {
  window.getApp.$emit("APP_API_CALL_STARTED", resource);

  return http
    .post(resource, jsonToSubmit)
    .then(response => {
      if (response.status == 200) {
        window.getApp.$emit("APP_API_CALL_SUCCESS", response);
        return response;
      } else {
        window.getApp.$emit("APP_API_CALL_FAILED", response);
        return Promise.reject(response);
      }
    })
    .catch(error => {
      if (error.response.status != 404) {
        window.getApp.$emit("APP_API_CALL_ERROR", error.response);
        return Promise.reject(error.response);
      } else {
        window.getApp.$emit("APP_API_NO_TERMS", error.response);
        return Promise.reject(error.response);
      }
    });
}

function get(resource) {
  window.getApp.$emit("APP_API_CALL_STARTED", resource);

  return http
    .get(resource)
    .then(response => {
      if (response.status == 200) {
        window.getApp.$emit("APP_API_CALL_SUCCESS", response);
        return response;
      } else {
        window.getApp.$emit("APP_API_CALL_FAILED", response);
        return Promise.reject(response);
      }
    })
    .catch(response => {
      window.getApp.$emit("APP_API_CALL_ERROR", response);
      return Promise.reject(response);
    });
}

export default class WordMasterService {
  fetchStatistics() {
    return get("https://api.termbank.valeontis.com/api/statistics");
  }

  fetchDatabases() {
    return get("https://api.termbank.valeontis.com/api/termbases");
  }

  fetchRandomTerm(database, allow_symbols, max_len_term_gr, max_len_term_en) {
    return post("https://api.termbank.valeontis.com/api/entry/random", {
      database: database,
      allow_symbols: allow_symbols,
      max_len_term_gr: max_len_term_gr,
      max_len_term_en: max_len_term_en
    });
  }

  fetchTerm(uid) {
    return get("https://api.termbank.valeontis.com/api/entry/index/uid/" + uid);
  }
}
